import React from 'react';

const SiriSpinner = ({ size = 'medium', text = '' }) => {
  const sizeMap = {
    small: 32,
    medium: 48,
    large: 64,
    xlarge: 96
  };

  const spinnerSize = sizeMap[size] || sizeMap.medium;
  const borderWidth = size === 'small' ? 3 : size === 'xlarge' ? 6 : 4;

  return (
    <div className="flex flex-col items-center justify-center gap-2">
      <div 
        className="relative rounded-full"
        style={{ 
          width: spinnerSize, 
          height: spinnerSize 
        }}
      >
        {/* Spinning gradient ring */}
        <div 
          className="absolute inset-0 rounded-full animate-spin"
          style={{
            background: 'conic-gradient(from 0deg, #667eea, #764ba2, #f093fb, #f5576c, #4facfe, #667eea)',
            animationDuration: '2s'
          }}
        />
        {/* White center to create ring effect */}
        <div 
          className="absolute rounded-full bg-white"
          style={{
            inset: borderWidth
          }}
        />
      </div>
      {text && (
        <span className="text-sm text-gray-600 font-medium">{text}</span>
      )}
    </div>
  );
};

export default SiriSpinner;
